import React, {useRef, useState, useEffect} from "react";
import './styles/unique_goods_order_popup.css'
import useOutsideClick from "../Constants/useOutsideClick";
import {bodyOverflow} from "../Constants/bodyOverflow";
import CheckBox from "./CheckBox";
import TextInput from "./TextInput";
import fAPI from "../fAPI";
import close_icon from "../assets/vector_close.svg";

export default function UniqueGoodsOrderPopup(props) {
    const [isLogged, setIsLogged] = useState(false)

    const {
        setModalState, modalState, setModalPopup,
        handlePopupData, adminConfirmModal, handleDelete
    } = props

    let ref = useRef();

    useEffect(() => {
        fAPI().get(`/user/profile`)
            .then(res => {
                Object.entries(res.data).forEach(i => {
                    if (modalState.hasOwnProperty(i[0]) && i[1]) {
                        setModalState(prevState => ({
                            ...prevState,
                            [i[0]]: {
                                ...prevState[i[0]],
                                value: [i[1]],
                                error: false,
                            }
                        }))
                    }
                })
                console.log('res')
                setIsLogged(true)
            })
            .catch(() => {
                console.log(123)
                setIsLogged(false)
            })
        //eslint-disable-next-line
    }, [])

    useOutsideClick(ref, () => {
        setModalPopup(false)
        bodyOverflow(false)
    });

    return (

        <div className={'unique_goods_order_popup'}>
            <div className={'unique_goods_order_popup_content'}>
                <img src={close_icon} onClick={() => {
                    setModalPopup(false)
                    bodyOverflow(false)
                }} className={'close-icon'} alt=""/>
                {adminConfirmModal
                    ? <div>
                        <h2>Удалить запрос</h2>
                        <p>Вы действительно хотите удалить запрос, это действие невозможно отменить.</p>
                        <div className={'unique_goods_order_popup_content_admin_buttons'}>
                            <button onClick={() => handleDelete()}>Удалить</button>
                            <button onClick={() => setModalPopup(false)}>Отмена</button>
                        </div>
                    </div>
                    : <form onSubmit={(e) => handlePopupData(e)}>
                        <h2>Расчётная цена</h2>
                        <p>Оставьте свой заказ и мы с Вами свяжемся</p>
                        <TextInput error={modalState.name.error}
                                   errorModal={modalState.name.error}
                                   errTitle={modalState.name.errorMessage}
                                   type={'text'}
                                   margin={'0 0 20px'}
                                   placeholder={'Имя'}
                                   goods
                                   value={modalState.name.value}
                                   onChange={({target}) => setModalState(prevState => ({
                                       ...prevState,
                                       name: {
                                           ...prevState.name,
                                           value: target.value,
                                           error: false,
                                       }
                                   }))}
                        />
                        <TextInput error={modalState.phone.error}
                                   errTitle={modalState.phone.errorMessage}
                                   errorModal={modalState.phone.error}
                                   type={'text'}
                                   goods
                                   margin={'0 0 20px'}
                                   placeholder={'Номер телефона'}
                                   value={modalState.phone.value}
                                   onChange={({target}) => {
                                       const RegEx = /^\+?(?:[\d]*)$/;
                                       if (RegEx.test(target.value) && target.value.length < 14) {
                                           setModalState(prevState => ({
                                               ...prevState,
                                               phone: {
                                                   ...prevState.phone,
                                                   value: target.value,
                                                   error: false,
                                               }
                                           }))
                                       }
                                   }}
                        />
                        <TextInput error={modalState.email.error}
                                   errTitle={modalState.email.errorMessage}
                                   errorModal={modalState.email.error}
                                   type={'text'}
                                   goods
                                   margin={'0 0 20px'}
                                   placeholder={'Email'}
                                   value={modalState.email.value}
                                   onChange={({target}) => {
                                       setModalState(prevState => ({
                                           ...prevState,
                                           email: {
                                               ...prevState.email,
                                               value: target.value,
                                               error: false,
                                           }
                                       }))
                                   }}
                        />
                        {console.log(isLogged)}
                        {isLogged ||
                        <>
                            <TextInput error={modalState.password.error}
                                       errTitle={modalState.password.errorMessage}
                                       errorModal={modalState.password.error}
                                       type={'password'}
                                       goods
                                       margin={'0 0 20px'}
                                       placeholder={'Пароль'}
                                       value={modalState.password.value}
                                       onChange={({target}) => {
                                           setModalState(prevState => ({
                                               ...prevState,
                                               password: {
                                                   ...prevState.password,
                                                   value: target.value,
                                                   error: false,
                                               }
                                           }))
                                       }}
                            />
                            <TextInput error={modalState.confirmPassword.error}
                                       errTitle={modalState.confirmPassword.errorMessage}
                                       errorModal={modalState.confirmPassword.error}
                                       type={'password'}
                                       goods
                                       margin={'0 0 20px'}
                                       placeholder={'Подтвердите пароль'}
                                       value={modalState.confirmPassword.value}
                                       onChange={({target}) => {
                                           setModalState(prevState => ({
                                               ...prevState,
                                               confirmPassword: {
                                                   ...prevState.confirmPassword,
                                                   value: target.value,
                                                   error: false,
                                               }
                                           }))
                                       }}
                            />
                        </>}
                        <button type={'submit'}>Отправить запрос</button>

                        <CheckBox text={'Я согласен на обработку моих данных'}
                                  handleChange={() => setModalState(prevState => ({
                                      ...prevState,
                                      agreeProcess: {
                                          value: !modalState.agreeProcess.value,
                                          error: false
                                      }
                                  }))}
                                  name={'agreeProcess'}
                                  error={modalState.agreeProcess.error}
                                  value={modalState.agreeProcess.value}/>
                    </form>}
            </div>
        </div>
    )
}